"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyTransferBaseTokenStep = void 0;
const step_1 = require("../step");
const constants_1 = require("../../models/constants");
class EmptyTransferBaseTokenStep extends step_1.Step {
    config = {
        name: 'Empty Transfer Base Token',
        description: 'Used for testing. Sends a 0-token transfer to a null address.',
    };
    toAddress = constants_1.ZERO_ADDRESS;
    amount = 0n;
    constructor() {
        super();
    }
    async getStepOutput(input) {
        const { erc20Amounts } = input;
        const unusedERC20Amounts = erc20Amounts;
        const crossContractCalls = [
            {
                data: '0x',
                to: this.toAddress,
                value: this.amount,
            },
        ];
        return {
            crossContractCalls,
            outputERC20Amounts: unusedERC20Amounts,
            outputNFTs: input.nfts,
        };
    }
}
exports.EmptyTransferBaseTokenStep = EmptyTransferBaseTokenStep;
